import { AlertTriangle } from 'lucide-react';
import { TEXTO_AVISO_IA } from './formato';

/** Aviso obrigatório: o resultado é sugestão da IA e precisa ser conferido pelo usuário. */
export default function AvisoSugestaoIA({ compacto = false }) {
  return (
    <div
      role="note"
      className={`flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 text-amber-800 ${compacto ? 'px-3 py-2 text-xs' : 'px-4 py-3 text-sm'}`}
    >
      <AlertTriangle className={`flex-shrink-0 text-amber-600 ${compacto ? 'w-4 h-4' : 'w-5 h-5'}`} />
      <p><strong>Sugestão da IA — confira antes de usar.</strong> {TEXTO_AVISO_IA}</p>
    </div>
  );
}
